import Vue from 'vue'
// import VueRouter from 'vue-router'
import Router from 'vue-router'
import firebase from 'firebase'

// Vue.use(VueRouter)
//
//   const routes = [
//     {
//       path: '*',
//       redirect: 'auth'
//     },
//
//   {
//     path: '/create',
//     name: 'create-letter',
//     component: () => import('../views/CreateLetter.vue'),
//     meta: { requiresAuth: true }
//   },
//   {
//     path: '/',
//     name: 'inbox',
//     component: () => import('../views/Inbox.vue'),
//     meta: { requiresAuth: true }
//   },
//   {
//     path: '/show/:id',
//     name: 'show-letter',
//     component: () => import('../views/ShowLetter.vue'),
//     meta: { requiresAuth: true }
//   },
//   {
//     path: '/auth',
//     name: 'auth',
//     component: () => import('../views/Auth.vue')
//   },
//
//
// ]
//
// let router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '*',
      redirect: 'auth'
    },
    {
      path: '/create',
      name: 'create-letter',
      component: () => import('../views/CreateLetter.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/',
      name: 'inbox',
      component: () => import('../views/Inbox.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/show/:id',
      name: 'show-letter',
      component: () => import('../views/ShowLetter.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('../views/Auth.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          name: 'auth'
        })
      }
    })
  } else {
    next() // next() を常に呼び出すようにしてください!
  }
})

export default router
